import React, { createContext, useContext, useEffect, useState } from "react";
import keycloak from "./keycloak";

// Déclarez le type pour `children` comme `React.ReactNode`
interface AuthContextProps {
  authenticated: boolean;
  login: () => void;
  logout: () => void;
  token: string | null;
}

interface AuthProviderProps {
  children: React.ReactNode; 
}

const AuthContext = createContext<AuthContextProps>({
  authenticated: false,
  login: () => {},
  logout: () => {},
  token: null,
});

export const AuthProvider: React.FC<AuthProviderProps> = ({ children }) => {
  const [authenticated, setAuthenticated] = useState(false);
  const [token, setToken] = useState<string | null>(null);

  useEffect(() => {
    keycloak
      .init({ onLoad: "login-required" })
      .then((authenticated) => {
        setAuthenticated(authenticated);
        setToken(keycloak.token || null);
        
          
          localStorage.setItem("jwt", keycloak.token || "");
      
      })
      .catch((error) => console.error("Erreur lors de l'initialisation de Keycloak", error));
  }, []);

  const login = () => keycloak.login();
  const logout = () => keycloak.logout();

  return (
    <AuthContext.Provider value={{ authenticated, login, logout, token }}>
      {children} {/* Affiche les enfants passés à AuthProvider */}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
